module.exports = __webpack_public_path__ + "img/feed3.5303b987.jpg";